import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_622cf0e1 from 'nuxt_plugin_plugin_622cf0e1' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_26c485a4 from 'nuxt_plugin_pluginutils_26c485a4' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_3dba39ef from 'nuxt_plugin_pluginrouting_3dba39ef' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2160e040 from 'nuxt_plugin_pluginmain_2160e040' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_portalvue_1cbbcd88 from 'nuxt_plugin_portalvue_1cbbcd88' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d4d311c2 from 'nuxt_plugin_cookieuniversalnuxt_d4d311c2' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_appVersion_b8fb86ae from 'nuxt_plugin_appVersion_b8fb86ae' // Source: ../src/plugins/appVersion.js (mode: 'all')
import nuxt_plugin_sentryclient_4d0dc30a from 'nuxt_plugin_sentryclient_4d0dc30a' // Source: ../src/plugins/client/sentry.client.js (mode: 'client')
import nuxt_plugin_date_3499abd2 from 'nuxt_plugin_date_3499abd2' // Source: ../src/plugins/date.js (mode: 'all')
import nuxt_plugin_notify_106da7d2 from 'nuxt_plugin_notify_106da7d2' // Source: ../src/plugins/notify.js (mode: 'all')
import nuxt_plugin_log_536d6a6c from 'nuxt_plugin_log_536d6a6c' // Source: ../src/plugins/log.js (mode: 'all')
import nuxt_plugin_autoReloadclient_5f12bcda from 'nuxt_plugin_autoReloadclient_5f12bcda' // Source: ../src/plugins/client/autoReload.client.js (mode: 'client')
import nuxt_plugin_permissionsclient_70d3a516 from 'nuxt_plugin_permissionsclient_70d3a516' // Source: ../src/plugins/client/permissions.client.js (mode: 'client')
import nuxt_plugin_networkclient_2d40081f from 'nuxt_plugin_networkclient_2d40081f' // Source: ../src/plugins/client/network.client.js (mode: 'client')
import nuxt_plugin_nativeInitclient_fa41a8b4 from 'nuxt_plugin_nativeInitclient_fa41a8b4' // Source: ../src/plugins/native/nativeInit.client.js (mode: 'client')
import nuxt_plugin_overTheAirUpdatesclient_595894ba from 'nuxt_plugin_overTheAirUpdatesclient_595894ba' // Source: ../src/plugins/native/overTheAirUpdates.client.js (mode: 'client')
import nuxt_plugin_getStoreVersionclient_076a8caa from 'nuxt_plugin_getStoreVersionclient_076a8caa' // Source: ../src/plugins/native/getStoreVersion.client.js (mode: 'client')
import nuxt_plugin_nuxtError_67126069 from 'nuxt_plugin_nuxtError_67126069' // Source: ../src/plugins/nuxtError.js (mode: 'all')
import nuxt_plugin_posthogclient_a2d681de from 'nuxt_plugin_posthogclient_a2d681de' // Source: ../src/plugins/client/posthog.client.js (mode: 'client')
import nuxt_plugin_breakpoints_e577f0a8 from 'nuxt_plugin_breakpoints_e577f0a8' // Source: ../src/plugins/breakpoints.js (mode: 'all')
import nuxt_plugin_appMixin_fd334a40 from 'nuxt_plugin_appMixin_fd334a40' // Source: ../src/plugins/appMixin.js (mode: 'all')
import nuxt_plugin_model_57dec3da from 'nuxt_plugin_model_57dec3da' // Source: ../src/plugins/api/model.js (mode: 'all')
import nuxt_plugin_index_f90d6cde from 'nuxt_plugin_index_f90d6cde' // Source: ../src/plugins/api/index.js (mode: 'all')
import nuxt_plugin_locale_3e9b0f66 from 'nuxt_plugin_locale_3e9b0f66' // Source: ../src/plugins/locale.js (mode: 'all')
import nuxt_plugin_localeRedirect_4008fa2c from 'nuxt_plugin_localeRedirect_4008fa2c' // Source: ../src/plugins/localeRedirect.js (mode: 'all')
import nuxt_plugin_socialLoginclient_41e1c6ed from 'nuxt_plugin_socialLoginclient_41e1c6ed' // Source: ../src/plugins/client/socialLogin.client.js (mode: 'client')
import nuxt_plugin_formValidation_5ad49583 from 'nuxt_plugin_formValidation_5ad49583' // Source: ../src/plugins/formValidation.js (mode: 'all')
import nuxt_plugin_modal_6299f5fe from 'nuxt_plugin_modal_6299f5fe' // Source: ../src/plugins/modal.js (mode: 'all')
import nuxt_plugin_fontawesome_21e933da from 'nuxt_plugin_fontawesome_21e933da' // Source: ../src/plugins/fontawesome.js (mode: 'all')
import nuxt_plugin_confirm_7912624e from 'nuxt_plugin_confirm_7912624e' // Source: ../src/plugins/confirm.js (mode: 'all')
import nuxt_plugin_scrollclient_8b0fff10 from 'nuxt_plugin_scrollclient_8b0fff10' // Source: ../src/plugins/client/scroll.client.js (mode: 'client')
import nuxt_plugin_resizeObserverclient_b9fd27d6 from 'nuxt_plugin_resizeObserverclient_b9fd27d6' // Source: ../src/plugins/client/resizeObserver.client.js (mode: 'client')
import nuxt_plugin_logProcessorclient_44ccec59 from 'nuxt_plugin_logProcessorclient_44ccec59' // Source: ../src/plugins/client/logProcessor.client.js (mode: 'client')
import nuxt_plugin_lazyLoadImagesclient_4efbe7fd from 'nuxt_plugin_lazyLoadImagesclient_4efbe7fd' // Source: ../src/plugins/client/lazyLoadImages.client.js (mode: 'client')
import nuxt_plugin_openWindowclient_6dd7edc5 from 'nuxt_plugin_openWindowclient_6dd7edc5' // Source: ../src/plugins/client/openWindow.client.js (mode: 'client')
import nuxt_plugin_forceNextTickclient_e7fd8aa8 from 'nuxt_plugin_forceNextTickclient_e7fd8aa8' // Source: ../src/plugins/client/forceNextTick.client.js (mode: 'client')
import nuxt_plugin_activityRefreshclient_2e209386 from 'nuxt_plugin_activityRefreshclient_2e209386' // Source: ../src/plugins/client/activityRefresh.client.js (mode: 'client')
import nuxt_plugin_fetchStatusclient_449ea386 from 'nuxt_plugin_fetchStatusclient_449ea386' // Source: ../src/plugins/client/fetchStatus.client.js (mode: 'client')
import nuxt_plugin_hoverIntentclient_e76a722e from 'nuxt_plugin_hoverIntentclient_e76a722e' // Source: ../src/plugins/client/hoverIntent.client.js (mode: 'client')
import nuxt_plugin_copyToClipboardclient_379d6b97 from 'nuxt_plugin_copyToClipboardclient_379d6b97' // Source: ../src/plugins/client/copyToClipboard.client.js (mode: 'client')
import nuxt_plugin_fileclient_6ab65fa7 from 'nuxt_plugin_fileclient_6ab65fa7' // Source: ../src/plugins/client/file.client.js (mode: 'client')
import nuxt_plugin_sessionRecordingclient_3472afe6 from 'nuxt_plugin_sessionRecordingclient_3472afe6' // Source: ../src/plugins/client/sessionRecording.client.js (mode: 'client')
import nuxt_plugin_liveChatclient_1e655c0f from 'nuxt_plugin_liveChatclient_1e655c0f' // Source: ../src/plugins/client/liveChat.client.js (mode: 'client')
import nuxt_plugin_keyboardclient_25e06e06 from 'nuxt_plugin_keyboardclient_25e06e06' // Source: ../src/plugins/native/keyboard.client.js (mode: 'client')
import nuxt_plugin_statusBarclient_7f736304 from 'nuxt_plugin_statusBarclient_7f736304' // Source: ../src/plugins/native/statusBar.client.js (mode: 'client')
import nuxt_plugin_iconclient_cd505ed0 from 'nuxt_plugin_iconclient_cd505ed0' // Source: ../src/plugins/native/icon.client.js (mode: 'client')
import nuxt_plugin_liveActivityclient_3adb3cba from 'nuxt_plugin_liveActivityclient_3adb3cba' // Source: ../src/plugins/native/liveActivity.client.js (mode: 'client')
import nuxt_plugin_pushNotificationsclient_09d3f72a from 'nuxt_plugin_pushNotificationsclient_09d3f72a' // Source: ../src/plugins/native/pushNotifications.client.js (mode: 'client')
import nuxt_plugin_biometricsclient_eb0560cc from 'nuxt_plugin_biometricsclient_eb0560cc' // Source: ../src/plugins/native/biometrics.client.js (mode: 'client')
import nuxt_plugin_initclient_5b30663b from 'nuxt_plugin_initclient_5b30663b' // Source: ../src/plugins/client/init.client.js (mode: 'client')
import nuxt_plugin_iframeclient_3ac408e2 from 'nuxt_plugin_iframeclient_3ac408e2' // Source: ../src/plugins/client/iframe.client.js (mode: 'client')
import nuxt_plugin_elementReadyclient_e001b91c from 'nuxt_plugin_elementReadyclient_e001b91c' // Source: ../src/plugins/client/elementReady.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":function anonymous(titleChunk
) {
return titleChunk
        ? `${titleChunk} - Paw Paddock`
        : 'Paw Paddock - Exclusive, Enclosed and Secure Dog Walking'
},"script":[{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F","id":"stripe","body":true,"async":true,"defer":true},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Frrweb@latest\u002Fdist\u002Fplugins\u002Fconsole-record.min.js","id":"rrwebconsole","body":true,"async":true,"defer":true},{"src":"https:\u002F\u002Fappleid.cdn-apple.com\u002Fappleauth\u002Fstatic\u002Fjsapi\u002Fappleid\u002F1\u002Fen_US\u002Fappleid.auth.js","body":true,"async":true,"defer":true}],"meta":[{"hid":"viewport","name":"viewport","content":"viewport-fit=cover, width=device-width, initial-scale=1.0, user-scalable=no"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fassets.pawpaddock.co.uk\u002Fassets\u002Fimages\u002Fapp\u002Fog.jpg"},{"hid":"theme-color","name":"theme-color","content":"#FFFFFF"},{}],"link":[{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon.png"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_622cf0e1 === 'function') {
    await nuxt_plugin_plugin_622cf0e1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_26c485a4 === 'function') {
    await nuxt_plugin_pluginutils_26c485a4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3dba39ef === 'function') {
    await nuxt_plugin_pluginrouting_3dba39ef(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2160e040 === 'function') {
    await nuxt_plugin_pluginmain_2160e040(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_1cbbcd88 === 'function') {
    await nuxt_plugin_portalvue_1cbbcd88(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d4d311c2 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d4d311c2(app.context, inject)
  }

  if (typeof nuxt_plugin_appVersion_b8fb86ae === 'function') {
    await nuxt_plugin_appVersion_b8fb86ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_4d0dc30a === 'function') {
    await nuxt_plugin_sentryclient_4d0dc30a(app.context, inject)
  }

  if (typeof nuxt_plugin_date_3499abd2 === 'function') {
    await nuxt_plugin_date_3499abd2(app.context, inject)
  }

  if (typeof nuxt_plugin_notify_106da7d2 === 'function') {
    await nuxt_plugin_notify_106da7d2(app.context, inject)
  }

  if (typeof nuxt_plugin_log_536d6a6c === 'function') {
    await nuxt_plugin_log_536d6a6c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_autoReloadclient_5f12bcda === 'function') {
    await nuxt_plugin_autoReloadclient_5f12bcda(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_permissionsclient_70d3a516 === 'function') {
    await nuxt_plugin_permissionsclient_70d3a516(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_networkclient_2d40081f === 'function') {
    await nuxt_plugin_networkclient_2d40081f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nativeInitclient_fa41a8b4 === 'function') {
    await nuxt_plugin_nativeInitclient_fa41a8b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_overTheAirUpdatesclient_595894ba === 'function') {
    await nuxt_plugin_overTheAirUpdatesclient_595894ba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_getStoreVersionclient_076a8caa === 'function') {
    await nuxt_plugin_getStoreVersionclient_076a8caa(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtError_67126069 === 'function') {
    await nuxt_plugin_nuxtError_67126069(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_posthogclient_a2d681de === 'function') {
    await nuxt_plugin_posthogclient_a2d681de(app.context, inject)
  }

  if (typeof nuxt_plugin_breakpoints_e577f0a8 === 'function') {
    await nuxt_plugin_breakpoints_e577f0a8(app.context, inject)
  }

  if (typeof nuxt_plugin_appMixin_fd334a40 === 'function') {
    await nuxt_plugin_appMixin_fd334a40(app.context, inject)
  }

  if (typeof nuxt_plugin_model_57dec3da === 'function') {
    await nuxt_plugin_model_57dec3da(app.context, inject)
  }

  if (typeof nuxt_plugin_index_f90d6cde === 'function') {
    await nuxt_plugin_index_f90d6cde(app.context, inject)
  }

  if (typeof nuxt_plugin_locale_3e9b0f66 === 'function') {
    await nuxt_plugin_locale_3e9b0f66(app.context, inject)
  }

  if (typeof nuxt_plugin_localeRedirect_4008fa2c === 'function') {
    await nuxt_plugin_localeRedirect_4008fa2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socialLoginclient_41e1c6ed === 'function') {
    await nuxt_plugin_socialLoginclient_41e1c6ed(app.context, inject)
  }

  if (typeof nuxt_plugin_formValidation_5ad49583 === 'function') {
    await nuxt_plugin_formValidation_5ad49583(app.context, inject)
  }

  if (typeof nuxt_plugin_modal_6299f5fe === 'function') {
    await nuxt_plugin_modal_6299f5fe(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_21e933da === 'function') {
    await nuxt_plugin_fontawesome_21e933da(app.context, inject)
  }

  if (typeof nuxt_plugin_confirm_7912624e === 'function') {
    await nuxt_plugin_confirm_7912624e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollclient_8b0fff10 === 'function') {
    await nuxt_plugin_scrollclient_8b0fff10(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_resizeObserverclient_b9fd27d6 === 'function') {
    await nuxt_plugin_resizeObserverclient_b9fd27d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_logProcessorclient_44ccec59 === 'function') {
    await nuxt_plugin_logProcessorclient_44ccec59(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyLoadImagesclient_4efbe7fd === 'function') {
    await nuxt_plugin_lazyLoadImagesclient_4efbe7fd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_openWindowclient_6dd7edc5 === 'function') {
    await nuxt_plugin_openWindowclient_6dd7edc5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_forceNextTickclient_e7fd8aa8 === 'function') {
    await nuxt_plugin_forceNextTickclient_e7fd8aa8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_activityRefreshclient_2e209386 === 'function') {
    await nuxt_plugin_activityRefreshclient_2e209386(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fetchStatusclient_449ea386 === 'function') {
    await nuxt_plugin_fetchStatusclient_449ea386(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hoverIntentclient_e76a722e === 'function') {
    await nuxt_plugin_hoverIntentclient_e76a722e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_copyToClipboardclient_379d6b97 === 'function') {
    await nuxt_plugin_copyToClipboardclient_379d6b97(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fileclient_6ab65fa7 === 'function') {
    await nuxt_plugin_fileclient_6ab65fa7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sessionRecordingclient_3472afe6 === 'function') {
    await nuxt_plugin_sessionRecordingclient_3472afe6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_liveChatclient_1e655c0f === 'function') {
    await nuxt_plugin_liveChatclient_1e655c0f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_keyboardclient_25e06e06 === 'function') {
    await nuxt_plugin_keyboardclient_25e06e06(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_statusBarclient_7f736304 === 'function') {
    await nuxt_plugin_statusBarclient_7f736304(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_iconclient_cd505ed0 === 'function') {
    await nuxt_plugin_iconclient_cd505ed0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_liveActivityclient_3adb3cba === 'function') {
    await nuxt_plugin_liveActivityclient_3adb3cba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pushNotificationsclient_09d3f72a === 'function') {
    await nuxt_plugin_pushNotificationsclient_09d3f72a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_biometricsclient_eb0560cc === 'function') {
    await nuxt_plugin_biometricsclient_eb0560cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initclient_5b30663b === 'function') {
    await nuxt_plugin_initclient_5b30663b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_iframeclient_3ac408e2 === 'function') {
    await nuxt_plugin_iframeclient_3ac408e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_elementReadyclient_e001b91c === 'function') {
    await nuxt_plugin_elementReadyclient_e001b91c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
